import isEmail from "validator/lib/isEmail";

const EMAIL_VALIDATION_OPTIONS = {
  allow_display_name: false,
  allow_ip_domain: false,
  allow_utf8_local_part: false,
  require_tld: true,
};

export const isValidEmail = (email: string): boolean => {
  if (typeof email !== "string") {
    return false;
  }

  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    return false;
  }

  return isEmail(trimmedEmail, EMAIL_VALIDATION_OPTIONS);
};
